// TDE new-device approval (GOOGLE_SSO_PLAN.md, Phase 3). Sent by an already-trusted, unlocked
// device: the UserKey wrapped under the requesting device's public key. The backend takes the
// new trusted device's public key and identifier from the stored request, not from here.
export class ApproveDeviceRequest {
  encryptedUserKey: string;

  constructor(encryptedUserKey: string) {
    this.encryptedUserKey = encryptedUserKey;
  }
}
